import { render } from "./mentions.vue?vue&type=template&id=e2a606c4"
import script from "./mentions.js?vue&type=script&lang=js&external"
export * from "./mentions.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__